<template>
  <v-list-tile :key="`load_assign_${load.humanId}`"
               ripple
               avatar>
    <v-list-tile-action>
      <v-btn color="accent" fab small
             @click.stop.prevent="$emit('viewLoad')">
        <v-icon>visibility</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title>
        {{ haulingCompany.name }}
      </v-list-tile-title>
      <v-list-tile-sub-title class="text--primary">
        {{ load.tacticalInfo.scheduledPickupTime | formatDate }}
      </v-list-tile-sub-title>
      <v-list-tile-sub-title>
        {{ load.humanId }}
        <span class="red--text" v-if="load.terms.freightSettlement">
          , ${{ load.terms.freightSettlement[0].amount }}
        </span>
        <span class="green--text" v-if="load.terms.customerSettlement">
          , ${{ load.terms.customerSettlement.amount }}
        </span>
      </v-list-tile-sub-title>
      <v-list-tile-sub-title>
                      <span class="font-italic" v-if="driverId">
                {{ driverName }}
              </span>
        <span class="font-italic" v-else-if="assignedVendor">
                Outside Vendor: {{ assignedVendor.name }}
          <dispatcher-info fab :vendor-dispatcher="assignedVendor" :company="company" />
        </span>
        <span class="font-italic" v-else>(no driver assigned)</span>

      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-avatar v-if="isLoadOwner">
      <v-btn fab flat color="accent"
             :disabled="isBookedLoadCanceled(load)"
             @click.stop.prevent="$emit('cancelLoad', load)">
        <v-icon>cancel</v-icon>
      </v-btn>
    </v-list-tile-avatar>
  </v-list-tile>
</template>

<script>
import * as Loads from '@/types/models/load';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import DispatcherInfo from '@/components/qb/DispatcherInfo';

export default {
  name: 'VBookedLoadPlannerListTile',
  props: {
    load: {
      type: Object,
      required: true,
    },
    isLoadOwner: {
      type: Boolean,
      default: true,
    },
    company: {
      type: Object,
    },
  },
  components: {
    DispatcherInfo,
  },
  mixins: [
    bookedLoadMixin,
  ],
  computed: {
    assignedVendor() {
      return this.bookedLoadVendorCarrierCompany(this.load);
    },
    haulingCompany() {
      return this.bookedLoadHaulingCompany(this.load);
    },
    driverId() {
      return Loads.assignedTruckingCompanyDriverUserId(this.load);
    },
    driverName() {
      return Loads.assignedTruckingCompanyDriverName(this.load);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/components/BookedLoadPlannerListTile.vue